import React, { useState } from "react";
import Brands from "../../common/Brands/Brands";
import Contact from "../../common/Contact/Contact";
import FooterThree from "../../common/Footer/FooterThree";
import Menu from "../../common/Menu/Menu";
import Testimonial from "../../common/Testimonial/Testimonial";
import OurService from "./OurService";
import ServiceAbout from "./ServiceAbout";
import ServiceBanner from "./ServiceBanner";
import ElevatorLoader from "../../Loder/ElevatorLoader";

const Service = () => {
  const [loading, setLoading] = useState(true);
  return (
    
<div>
      {loading && <ElevatorLoader onFinish={() => setLoading(false)} />}
      <Menu header_style_2={true} />
      <ServiceBanner />
      <OurService />
      <ServiceAbout />
      <Contact />
      <Testimonial />
      {/* <Brands /> */}
      <FooterThree />
    </div>
  );
};

export default Service;
